import Loadable from 'react-loadable'
import LoadingComponent from 'components/common/loading-component'
const InsightsRecipientsLoader: any = Loadable({
  // @ts-ignore
  loader: () => import('./index'),
  loading: LoadingComponent,
})
export default InsightsRecipientsLoader
